import React from 'react';
import { Link } from 'react-router-dom';
import { courseGroups, courses } from '../../data/courses';
import { destinations } from '../../data/destinations';
import { aboutLinks, resourceLinks } from '../../data/navigation';
import { StatusBadge } from '../ui/StatusBadge';
import { TextLink } from '../ui/TextLink';
import { destinationPath, programmePath } from '../../utils/paths';
import type { MenuId } from '../../types/content';
const linkClass = 'block rounded-lg py-1.5 type-card-desc text-body transition-colors duration-150 hover:text-ink';
const groupTitle = 'type-h5 text-ink';
export function NavPanel({
  id
}: {
  id: MenuId;
}) {
  if (id === 'programmes') return <ProgrammesPanel data-id="element-636" data-mp="1urimeig4aukb" />;
  if (id === 'destinations') return <DestinationsPanel data-id="element-637" data-mp="1upxsmv1mnfni" />;
  return <AboutPanel data-id="element-638" data-mp="1up5vvgwanbvn" />;
}
function ProgrammesPanel() {
  return <div data-id="element-639" data-mp="2igbdo1lsoe8l">
      <div className="grid grid-cols-4 gap-10" data-id="element-640" data-mp="2ifjnx7evpaq8">
        {courseGroups.map(group => <div key={group.id} data-id="element-641" data-mp="2n8l6pqi7huf3">
            <p className={groupTitle} data-id="element-642" data-mp="2n9nzy53048y6">{group.label}</p>
            <ul className="mt-3" data-id="element-643" data-mp="ieh2n99rabq7">
              {courses.filter(course => course.group === group.id).map(course => <li key={course.slug} data-id="element-644" data-mp="s38vdjmn5026">
                    <Link to={programmePath(course.slug)} className={linkClass} data-id="element-645" data-mp="s40q6s8eytre">
                      {course.name}
                    </Link>
                  </li>)}
            </ul>
          </div>)}
      </div>
      <div className="mt-8 border-t border-line pt-6" data-id="element-646" data-mp="11606fiblttta">
        <TextLink to="/programmes" data-id="element-647" data-mp="w3sqkhnnltlo">All programmes</TextLink>
      </div>
    </div>;
}
function DestinationsPanel() {
  const yearRound = destinations.filter(destination => destination.yearRound);
  const seasonal = destinations.filter(destination => destination.seasonal);
  return <div className="grid grid-cols-4 gap-10" data-id="element-648" data-mp="3csogpz33bwkf">
      <div data-id="element-649" data-mp="3cvkdhk37cf7a">
        <p className={groupTitle} data-id="element-650" data-mp="3cvaw2kw83gd7">Year-round</p>
        <ul className="mt-3" data-id="element-651" data-mp="37vesgmrftqy6">
          {yearRound.map(destination => <li key={destination.slug} data-id="element-652" data-mp="1dmn2vu8fs2u">
              <Link to={destinationPath(destination, 'year-round')} className={linkClass} data-id="element-653" data-mp="1epf573ak0kc">
                {destination.name}
              </Link>
            </li>)}
        </ul>
        <div className="mt-6" data-id="element-654" data-mp="ad1fi0tymcpz">
          <TextLink to="/destinations" data-id="element-655" data-mp="afvzjr929viv">All destinations</TextLink>
        </div>
      </div>
      <div className="col-span-3 border-l border-line pl-10" data-id="element-656" data-mp="fe753psbpjva">
        <p className={groupTitle} data-id="element-657" data-mp="kaxnwkviitke">Seasonal</p>
        <ul className="mt-3 grid grid-cols-3 gap-x-10" data-id="element-658" data-mp="k9w8k47grkwv">
          {seasonal.map(destination => <li key={destination.slug} data-id="element-659" data-mp="ob7r5prx75vk">
              <Link to={destinationPath(destination, 'seasonal')} className={linkClass} data-id="element-660" data-mp="t40y8kav2qat">
                {destination.name}
              </Link>
            </li>)}
        </ul>
      </div>
    </div>;
}
function AboutPanel() {
  return <div className="grid grid-cols-4 gap-10" data-id="element-661" data-mp="130dpzcmuiu2x">
      <div className="col-span-2" data-id="element-662" data-mp="180rz6y06oa2j">
        <p className={groupTitle} data-id="element-663" data-mp="18235b4h3ptwt">ES World</p>
        <ul className="mt-3 grid grid-cols-2 gap-x-10" data-id="element-664" data-mp="2sjcaoku74jd3">
          {aboutLinks.map(link => <li key={link.to} data-id="element-665" data-mp="2nkslmbkb2rgi">
              <Link to={link.to} className={`${linkClass} flex items-center gap-2`} data-id="element-666" data-mp="2njhfi53e17m8">
                {link.label}
                {link.comingSoon ? <StatusBadge data-id="element-667" data-mp="2inimu5b113g0">Coming soon</StatusBadge> : null}
              </Link>
            </li>)}
        </ul>
      </div>
      <div className="col-span-2 border-l border-line pl-10" data-id="element-668" data-mp="3b9txk8sckkqj">
        <p className={groupTitle} data-id="element-669" data-mp="3b9bx0zynjkct">Resources</p>
        <ul className="mt-3 grid grid-cols-2 gap-x-10" data-id="element-670" data-mp="36ah3b2z5cbdx">
          {resourceLinks.map(link => <li key={link.to} data-id="element-671" data-mp="31jsczqz7dkgd">
              <Link to={link.to} className={linkClass} data-id="element-672" data-mp="31ipjrceer5xa">
                {link.label}
              </Link>
            </li>)}
        </ul>
      </div>
    </div>;
}